import { formatDate } from 'react-day-picker/moment';
import { apiGet, apiPost, getHostApi } from '../../apiWrapper';
import { _formatDate, _handleError, _parseDate } from '../common/functions';
import { _insertNewLink } from '../diagram/actions';
import { diagram } from '../diagram/initial';
import { _expandNodeFromDatabase } from '../diagram/templates/node';
import { _resetExportButtons } from "../exports/actions";
import { VISIBILITY_TYPE } from '../common/constants';
import { _collapseLevel } from '../diagram/visiblityActions';

// ACTIONS
const chartActions = {
    // CUSTOM RELATION
    addCustomRelation: (data, customLinkLabel) => async (dispatch, getState) => {
        if (data.entityData == null || data.entityData.EntityID !== 0)
            _addCustomRelation(data, customLinkLabel, dispatch, getState);
        else
            _addCustomEntity(data, customLinkLabel, dispatch, getState);
    },
    newCustomRelation: (entityData) => async (dispatch, getState) => {
        _newCustomRelation(entityData);
    },
    editCustomRelation: (data, customLinkLabel) => async (dispatch, getState) => {
        _editCustomRelation(data, customLinkLabel, dispatch, getState);
    },
    deleteCustomRelation: (relationId) => async (dispatch, getState) => {
        _deleteCustomRelation(relationId, dispatch);
    },
    addCustomRelationClick: () => async (dispatch, getState) => {
        if (diagram.selectedNodes.length === 2)
            _newCustomRelation(null);
        else if (diagram.selectedNodes.length === 1)
            diagram._showCustomSearchPopupFunc();
    },

    // CUSTOM ENTITY
    newCustomEntity: () => async (dispatch, getState) => {
        _newCustomEntity();
    },
    editCustomEntity: (data) => async (dispatch, getState) => {
        _editCustomEntity(data, dispatch, getState);
    },
}

// FUNCTIONS
// CUSTOM RELATION
function _addCustomRelation(data, customLinkLabel, dispatch, getState) {
    var groupsSharing = _parseGroupsSharing(data);
    var usersSharing = _parseUsersSharing(data);

    var parentNode = diagram.nodeDiagram.findNodeForKey(data.SubjectFrom);
    var childNode = diagram.nodeDiagram.findNodeForKey(data.SubjectTo);
    data.Polarity = 1;
    if (childNode === null || parentNode.data.Level < childNode.data.Level) {
        data.Polarity = -1;
    } else {
        let temp = data.SubjectFrom;
        data.SubjectFrom = data.SubjectTo;
        data.SubjectTo = temp;
    }

    apiPost(`${getHostApi()}/api/charts/add-custom-relation`, undefined, {
        parentEntId: data.SubjectFrom,
        childEntId: data.SubjectTo,
        startDate: _parseDate(data.StartDate),
        endDate: _parseDate(data.EndDate),
        share: data.SharePct || null,
        deposit: data.Deposit || null,
        currency: data.Currency || null,
        source: data.RelationSource || null,
        note: data.newNote,
        groupsSharing: groupsSharing,
        usersSharing: usersSharing,
        relationType: data.RelationShortening || null,
        polarity: data.data.BidirectionalRelation === 1 ? 0 : data.Polarity
    },
        (newData) => {
            if (data.entityData == null || data.entityData.EntityID === 0) {
                var parentNode = diagram.nodeDiagram.findNodeForKey(data.SubjectFrom);
                var childNode = diagram.nodeDiagram.findNodeForKey(data.SubjectTo);
                var polarity = data.data.BidirectionalRelation ? 0 : data.Polarity;
                var state = 0;
                if (_parseDate(data.EndDate) && _parseDate(data.EndDate) < Date.now()) {
                    state = 1;
                }
                var relationData = {
                    StartDate: _formatDate(_parseDate(data.StartDate)),
                    EndDate: _formatDate(_parseDate(data.EndDate)) || null,
                    RelationSource: data.RelationSource,
                    Deposit: data.Deposit || null,
                    SharePct: data.SharePct || null,
                    Currency: data.Currency || null,
                    Name: customLinkLabel,
                    RootRelationShortening: 'custom',
                    RelationShortening: data.RelationShortening || null,
                    UserId: diagram._currentUser.id,
                    RelationID: newData.data,
                    RelationType: 'NRCU',
                    Polarity: polarity,
                    State: state
                };
                relationData.CustomNotes = [];
                if (data.newNote !== '')
                    relationData.CustomNotes.push({
                        Note: data.newNote,
                        Updated: Date.now(),
                        UserFirstName: diagram._currentUser.name,
                        UserLastName: diagram._currentUser.surname,
                        UserId: diagram._currentUser.id
                    });
                _insertNewLink({
                    ChildID: data.SubjectTo,
                    ParentID: data.SubjectFrom,
                    TypeCD: 'CU',
                    RelationType: 'NRCU',
                    State: state,
                    RootGroupId: 'NRCU',
                    SharePct: data.SharePct || null,
                    RootRelationShortening: 'custom',
                    Guaranteed: 0,
                    RelationsData: [relationData],
                    Polarity: polarity
                });
                _incCustomRelationsAdded(parentNode, 1);
                _incCustomRelationsAdded(childNode, 1);
            }
            else {
                var node;
                if (data.entityData.EntityID === data.SubjectFrom)
                    node = diagram.nodeDiagram.findNodeForKey(data.SubjectTo);
                else
                    node = diagram.nodeDiagram.findNodeForKey(data.SubjectFrom);

                node.data.IsExpanded = true;
                _incCustomRelationsAdded(node, 1);
                _expandNodeFromDatabase(null, node, dispatch, getState, data.entityData.EntityID);
            }
            _resetExportButtons(dispatch);
        },
        e => _handleError("/api/charts/export/add-custom-relation error", e, getState)
    );
}

function _incCustomRelationsAdded(node, count) {
    if (node.data.customRelationsAdded === undefined)
        node.data.customRelationsAdded = count;
    else
        node.data.customRelationsAdded += count;
    if (node.data.TotalRelationsCount !== null) {
        const totalCount = node.data.TotalRelationsCount + count;
        diagram.nodeDiagram.model.commit(function (m) {
            m.set(node.data, "TotalRelationsCount", totalCount);
        });
    }
}

function _parseGroupsSharing(data) {
    var groupsSharing = [];
    data.data.Groups.forEach((g) => {
        if (g.checked) {
            groupsSharing.push(parseInt(g.id));
        }
    });
    return groupsSharing;
}

function _parseUsersSharing(data) {
    var usersSharing = [];
    data.data.Users.forEach((u) => {
        if (u.checked) {
            usersSharing.push(parseInt(u.id));
        }
    });
    return usersSharing
}

function _newCustomRelation(entityData) {
    apiGet(`${getHostApi()}/api/charts/custom-relation`, { relationId: 0 }, data => {
        data.RelationID = 0;
        data.CurrentUser = true;
        data.CurrentUserId = diagram._currentUser.id;
        data.RelationShortening = '';

        data.subjectOptions = [{ label: diagram.selectedNodes[0].val, value: diagram.selectedNodes[0].key }];
        if (entityData == null) {
            data.subjectOptions.push({ label: diagram.selectedNodes[1].val, value: diagram.selectedNodes[1].key });
            data.SubjectTo = diagram.selectedNodes[1].key;
        }
        else {
            data.subjectOptions.push({ label: entityData.Name, value: entityData.EntityID });
            data.SubjectTo = entityData.EntityID;
        }
        data.SubjectFrom = diagram.selectedNodes[0].key;
        data.StartDate = formatDate(new Date(), 'DD.MM.YYYY', 'cs');
        data.EndDate = null;
        data.SharePct = '';
        data.Deposit = '';
        data.Currency = '';
        data.RelationSource = '';
        data.entityData = entityData;
        data.data.BidirectionalRelation = false;
        diagram._showCustomRelationPopupFunc('add', data);
    });
}

function _editCustomRelation(data, customLinkLabel, dispatch, getState) {
    var notesToEdit = _parseNotes(data);
    var groupsSharing = _parseGroupsSharing(data);
    var usersSharing = _parseUsersSharing(data);

    if (data.Polarity !== 0) {
        if (data.Polarity === -1 && (data.originParentEntityId !== data.SubjectFrom)) {
            data.Polarity = data.Polarity * -1;
            let tmp = data.SubjectFrom;
            data.SubjectFrom = data.SubjectTo;
            data.SubjectTo = tmp;
        } else if (data.Polarity === 1 && (data.originParentEntityId === data.SubjectFrom)) {
            data.Polarity = data.Polarity * -1;
        }
    } else {
        if (data.originParentEntityId !== data.SubjectFrom) {
            data.Polarity = 1;
            let tmp = data.SubjectFrom;
            data.SubjectFrom = data.SubjectTo;
            data.SubjectTo = tmp;
        } else {
            data.Polarity = -1;
        }
    }

    apiPost(`${getHostApi()}/api/charts/update-custom-relation`, undefined, {
        parentEntId: data.SubjectFrom,
        childEntId: data.SubjectTo,
        startDate: _parseDate(data.StartDate),
        endDate: _parseDate(data.EndDate),
        share: data.SharePct || null,
        deposit: data.Deposit || null,
        currency: data.Currency || null,
        source: data.RelationSource || null,
        newNote: data.newNote,
        relationId: data.RelationID,
        notesToEdit: notesToEdit,
        groupsSharing: groupsSharing,
        usersSharing: usersSharing,
        relationType: data.RelationShortening || null,
        polarity: data.data.BidirectionalRelation ? 0 : data.Polarity
    },
        () => {
            var link = diagram.nodeDiagram.links.filter(function (f) { return f.data.RelationsData[0].RelationID === data.RelationID }).first();
            var relationUserId = link.data.RelationsData[0].UserId;
            diagram.nodeDiagram.model.removeLinkData(link.data);
            diagram._relationsOriented = diagram._relationsOriented.filter(function (f) { return f.RelationsData[0].RelationID !== data.RelationID });

            notesToEdit.forEach((n) => {
                if (n.note === '')
                    link.data.RelationsData[0].CustomNotes = link.data.RelationsData[0].CustomNotes.filter(function (v) { return v.RowId !== n.rowId });
                else {
                    var notes = link.data.RelationsData[0].CustomNotes.filter(function (v) { return v.RowId === n.rowId });
                    if (notes.length > 0)//else we don't have rowId, note was recently added :( ..todo
                        notes[0].Note = n.note;
                }
            });

            if (data.newNote !== '')
                link.data.RelationsData[0].CustomNotes.push({
                    Note: data.newNote,
                    Updated: Date.now(),
                    UserFirstName: diagram._currentUser.name,
                    UserLastName: diagram._currentUser.surname,
                    UserId: diagram._currentUser.id
                });

            var polarity = data.data.BidirectionalRelation ? 0 : data.Polarity;

            var state = 0;
            if (_parseDate(data.EndDate) && _parseDate(data.EndDate) < Date.now()) {
                state = 1;
            }
            var relationData = {
                StartDate: _formatDate(_parseDate(data.StartDate)),
                EndDate: _formatDate(_parseDate(data.EndDate)) || null,
                RelationSource: data.RelationSource,
                Deposit: data.Deposit || null,
                SharePct: data.SharePct || null,
                Currency: data.Currency || null,
                Name: customLinkLabel,
                RootRelationShortening: 'custom',
                RelationShortening: data.RelationShortening || null,
                UserId: relationUserId,
                RelationID: data.RelationID,
                RelationType: 'NRCU',
                Polarity: polarity,
                State: state
            };
            relationData.CustomNotes = link.data.RelationsData[0].CustomNotes;
            _insertNewLink({
                ChildID: data.SubjectTo,
                ParentID: data.SubjectFrom,
                TypeCD: 'CU',
                RelationType: 'NRCU',
                State: state,
                RootGroupId: 'NRCU',
                SharePct: data.SharePct || null,
                RootRelationShortening: 'custom',
                Guaranteed: 0,
                RelationsData: [relationData],
                Polarity: polarity
            });
            _resetExportButtons(dispatch);
        },
        e => _handleError("/api/charts/export/update-custom-relation error", e, getState)
    );
}

function _parseNotes(data) {
    var notesToEdit = [];
    data.data.Notes.forEach((note) => {
        notesToEdit.push({ rowId: note.RowId, note: note.Note });
    });
    return notesToEdit;
}

function _deleteCustomRelation(relationId, dispatch) {
    apiGet(`${getHostApi()}/api/charts/delete-custom-relation`, { relationId: relationId },
        () => {
            var link = diagram.nodeDiagram.links.filter(function (f) { return f.data.RelationsData[0].RelationID === relationId }).first();
            var chld = diagram.nodeDiagram.findNodeForKey(link.data.ChildID);
            var prnt = diagram.nodeDiagram.findNodeForKey(link.data.ParentID);
            diagram.nodeDiagram.model.removeLinkData(link.data);
            diagram._relationsOriented = diagram._relationsOriented.filter(function (f) { return f.RelationsData[0].RelationID !== relationId });
            _incCustomRelationsAdded(prnt, -1);
            var connections = chld.linksConnected;
            while (connections.next()) {
                var toNode = connections.value.toNode;
                if (chld.data.EntityID === toNode.data.EntityID) {
                    var fromNode = connections.value.fromNode;
                    if (toNode.data.Level > fromNode.data.Level || toNode.data.Level === fromNode.data.Level) {
                        _incCustomRelationsAdded(chld, -1);
                        return;
                    }
                }
            }
            _collapseLevel({ node: chld }, true, null, VISIBILITY_TYPE.hidden);
            diagram.nodeDiagram.startTransaction();
            diagram.nodeDiagram.remove(chld);
            diagram.nodeDiagram.commitTransaction("deleted node");
            _resetExportButtons(dispatch);
        });
}

// CUSTOM ENTITY
function _addCustomEntity(data, customLinkLabel, dispatch, getState) {
    var groupsSharing = _parseGroupsSharing(data.entityData);
    var usersSharing = _parseUsersSharing(data.entityData);

    apiPost(`${getHostApi()}/api/charts/add-custom-entity`, undefined, {
        subjectType: data.entityData.EntityType,
        name: data.entityData.Name,
        companyId: data.entityData.IC,
        dateOfBirth: _parseDate(data.entityData.DateOfBirthOrCreationDate),
        semaphoreCode: parseInt(data.entityData.SemaphoreCode || null),
        address: data.entityData.newAddress,
        note: data.entityData.newNote,
        groupsSharing: groupsSharing,
        usersSharing: usersSharing
    },
        (entId) => {
            data.entityData.EntityID = entId.data;
            var level = 0;
            if (data.SubjectFrom === 0) {
                level = diagram.nodeDiagram.findNodeForKey(data.SubjectTo).data.Level + 1;
                data.SubjectFrom = entId.data;
            }
            else {
                level = diagram.nodeDiagram.findNodeForKey(data.SubjectFrom).data.Level + 1;
                data.SubjectTo = entId.data;
            }

            var nodeData = {
                EntityID: entId.data,
                OriginalLevel: level,
                WarningShortcuts: [],
                WarningOverview: [],
                EntityType: data.entityData.EntityType,
                Name: data.entityData.Name,
                Type: "Custom",
                FullAddress: data.entityData.newAddress,
                SemaphoreCode: data.entityData.SemaphoreCode,
                IC: data.entityData.IC,
                DateOfBirthOrCreationDate: _parseDate(data.entityData.DateOfBirthOrCreationDate),
                HasAdditionalInfo: false,
                isRootForeign: false,
                isRootCzech: true,
                CountryCode: "00",
                isRootSlovak: false,
                UserId: diagram._currentUser.id,
                RelationsCount: 0,
                actualRelationsCount: 0,
            };
            if (data.entityData.newNote !== '')
                nodeData.CustomNotes = [{
                    Note: data.entityData.newNote,
                    Updated: Date.now(),
                    UserFirstName: diagram._currentUser.name,
                    UserLastName: diagram._currentUser.surname,
                    UserId: diagram._currentUser.id
                }];

            _addCustomRelation(data, customLinkLabel, dispatch, getState);
            _resetExportButtons(dispatch);
        },
        e => _handleError("/api/charts/export/add-custom-entity error", e, getState)
    );
}

function _newCustomEntity() {
    apiGet(`${getHostApi()}/api/charts/custom-entity`, { entId: 0 }, data => {
        data.EntityType = 'FO';
        data.Name = '';
        data.IC = '';
        data.DateOfBirthOrCreationDate = null;
        data.SemaphoreCode = '';
        data.CurrentUser = true;
        data.CurrentUserId = diagram._currentUser.id;
        data.EntityID = 0;
        diagram._showCustomEntityPopupFunc('add', data);
    });
}

function _editCustomEntity(data, dispatch, getState) {
    var notesToEdit = _parseNotes(data);
    var addressesToEdit = [];

    data.data.Addresses.forEach((addr) => {
        addressesToEdit.push({ rowId: addr.RowId, address: addr.Address });
    });

    var groupsSharing = _parseGroupsSharing(data);
    var usersSharing = _parseUsersSharing(data);

    apiPost(`${getHostApi()}/api/charts/update-custom-entity`, undefined, {
        subjectType: data.EntityType,
        name: data.Name,
        companyId: data.IC,
        dateOfBirth: _parseDate(data.DateOfBirthOrCreationDate),
        semaphoreCode: parseInt(data.SemaphoreCode || null),
        newAddress: data.newAddress,
        newNote: data.newNote,
        entityId: data.EntityID,
        notesToEdit: notesToEdit,
        addressesToEdit: addressesToEdit,
        groupsSharing: groupsSharing,
        usersSharing: usersSharing
    },
        () => {
            var fullAddr = "";
            var a = addressesToEdit.filter(function (v) { return v.address !== '' });
            if (a.length > 0)
                fullAddr = a[0].address;
            else
                fullAddr = data.newAddress;

            var node = diagram.nodeDiagram.findNodeForKey(data.EntityID);
            diagram.nodeDiagram.model.commit(function (m) {
                m.set(node.data, "Name", data.Name);
                m.set(node.data, "EntityType", data.EntityType);
                m.set(node.data, "SemaphoreCode", data.SemaphoreCode);
                m.set(node.data, "IC", data.IC);
                m.set(node.data, "DateOfBirthOrCreationDate", _parseDate(data.DateOfBirthOrCreationDate));
                m.set(node.data, "FullAddress", fullAddr);
            });

            notesToEdit.forEach((n) => {
                if (n.note === '')
                    node.data.CustomNotes = node.data.CustomNotes.filter(function (v) { return v.RowId !== n.rowId });
                else {
                    var notes = node.data.CustomNotes.filter(function (v) { return v.RowId === n.rowId });
                    if (notes.length > 0)//else we don't have rowId, note was recently added :( ..todo
                        notes[0].Note = n.note;
                }
            });

            if (data.newNote !== '')
                node.data.CustomNotes.push({
                    Note: data.newNote,
                    Updated: Date.now(),
                    UserFirstName: diagram._currentUser.name,
                    UserLastName: diagram._currentUser.surname,
                    UserId: diagram._currentUser.id
                });

            _resetExportButtons(dispatch);
        },
        e => _handleError("/api/charts/export/update-custom-entity error", e, getState)
    );
}

export { chartActions as customChartActions };
